export default "__VITE_ASSET__DDiay3eC__"